const AuthTokenKey = "token";

export const getAuthTokenFromLocalStorage = () => {
  return localStorage.getItem(AuthTokenKey);
};

export const removeAuthTokenFromLocalStorage = () => {
  localStorage.removeItem(AuthTokenKey);
};

export const setAuthTokenFromLocalStorage = (value: string) => {
  return localStorage.setItem(AuthTokenKey, value);
};

export const parseJwt = (token) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};

export const formatDateToString = (date: Date) => {
  const day = String(date.getDate()).padStart(2, "0"); // получаем день и добавляем ведущий ноль при необходимости
  const month = String((date.getMonth() + 1)).padStart(2, "0"); // получаем месяц и добавляем ведущий ноль при необходимости
  const year = date.getFullYear(); // получаем год
  const hours = String(date.getHours()).padStart(2, "0"); // получаем часы и добавляем ведущий ноль при необходимости
  const minutes = String(date.getMinutes()).padStart(2, "0"); // получаем минуты и добавляем ведущий ноль при необходимости
  const seconds = String(date.getSeconds()).padStart(2, "0"); // получаем секунды и добавляем ведущий ноль при необходимости
  const formattedDate = `${day}.${month}.${year}, ${hours}:${minutes}:${seconds}`; // объединяем значения в строку нужного формата
  return formattedDate;
};
